import styled from 'styled-components';

import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { phoneNumberFormatter, Translate } from '@dreryk/react-common';
import { FormLabel, resolveInputLayoutStyles } from '@dreryk/react-components';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';

import { patientTranslationKeys } from '../../translations';

export const StyledPatientRemovalInfo = styled.div`
   ${resolveInputLayoutStyles};
`;

StyledPatientRemovalInfo.displayName = 'StyledPatientRemovalInfo';

export const StyledPersonalData = styled.div`
   > span:after {
      content: ', ';
   }
   > span:last-child:after {
      content: '';
   }
`;

StyledPersonalData.displayName = 'StyledPersonalData';

type PatientRemovalInfoProps = {
   readonly patient: PatientSimple;
};

export const PatientRemovalInfo = (props: PatientRemovalInfoProps): JSX.Element => {
   return (
      <StyledPatientRemovalInfo>
         <FormLabel testId={'patientRemovalInfo'} label={patientTranslationKeys.patientData} />
         <StyledPersonalData>
            <span>
               {props.patient.firstName?.asString()} {props.patient.lastName?.asString()}
            </span>
            {props.patient.referenceIdentifier ? (
               <Translate>{getPatientReferenceIdentifierTranslatableText(props.patient.referenceIdentifier)}</Translate>
            ) : null}
         </StyledPersonalData>
         {props.patient.phoneNumber ? (
            <div>
               <Translate>{patientTranslationKeys.phoneAbbreviation}</Translate>
               {': '}
               {phoneNumberFormatter(props.patient.phoneNumber)}
            </div>
         ) : null}
      </StyledPatientRemovalInfo>
   );
};
